import { FAQ_UNAPPLIED_PUBLISHERS } from '@/constants/faq'
import { TARGET_PAGES, type TargetPageType } from '@/constants/routes'
import type { Publisher } from '@/types/supports'

export interface BridgeRouteInfo {
  url: string
  searchParams: URLSearchParams
}

export const extractApiParams = (queryParams: Record<string, string | null>) => ({
  appId: queryParams.appId || '',
  uid: queryParams.uid || '',
  googleAdId: queryParams.googleAdId || '',
  idfa: queryParams.idfa || '',
  advertisingId: queryParams.advertisingId || '',
  isLat: queryParams.isLat || '',
  osVer: queryParams.osVer || '',
  deviceModel: queryParams.deviceModel || '',
  appVer: queryParams.appVer || '',
  packageName: queryParams.packageName || '',
  sdkVer: queryParams.sdkVer || '',
  pubAppModuleName: queryParams.pubAppModuleName || '',
  pubAppModuleVer: queryParams.pubAppModuleVer || ''
})

export const resolveTargetPage = (target: TargetPageType, publisher: Publisher): TargetPageType => {
  if (target === TARGET_PAGES.FAQ && FAQ_UNAPPLIED_PUBLISHERS.includes(publisher.code.toUpperCase() as any)) {
    return TARGET_PAGES.SUPPORT
  }

  return target
}

/**
 * 최종 라우팅 URL 생성
 */
export const buildBridgeRouteUrl = (
  publisher: Publisher,
  targetPage: TargetPageType,
  queryParams: Record<string, string | null>
): BridgeRouteInfo => {
  const { code } = publisher
  const url = `/u/${code.toLocaleLowerCase()}/${targetPage}`

  const { target: _, ...rest } = queryParams
  const searchParams = new URLSearchParams(rest as Record<string, string>)

  searchParams.set('target', targetPage)

  return {
    url,
    searchParams
  }
}
